module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_4_2.6be93d25.png";